import axios from "axios";
import {
  Message,
  MessageBox
} from "element-ui";
import store from "@/store";
import router from '../router'
import Cookies from 'js-cookie'
import { Toast } from 'vant';
import {
  isWeixn,
  isAlipay
} from './index'
import {
  Dialog
} from 'vant';

function transform(data) {
  return new Promise(resolve => {
    let fr = new FileReader()
    fr.onload = () => {
      resolve(JSON.parse(fr.result).msg || JSON.parse(fr.result).data)
    }
    fr.readAsText(data, ['utf-8'])
  })
}

function cleanLocalToken() {
  window.localStorage.clear()
  Cookies.remove('userToken')
  Cookies.remove('userToken', { path: '/' })
  Cookies.remove('userToken', { path: '/addressCheck' })
  Toast.fail('当前环境异常，已自动修复，正在重新加载！');
  setTimeout(() => {
    window.location.reload()
  }, 1000)
}

var isStop = false
// 创建axios实例
// 重定向 登录 界面
function redirectLogin() {
  let url = window.location.pathname;
  if (
    ![
      "/staffRecord",
      "/interviewRegister",
      "/mobileQuestions",
      "/mobileBookActivity",
    ].includes(url)
  ) {
    // if (store.getters.systemType === "pc") {
    //   MessageBox.confirm(
    //     store.getters.authorization ?
    //       "当前用户登录时间超时，请重新登录" :
    //       "您还未登录，请先登录",
    //     "确认操作", {
    //     confirmButtonText: "确定",
    //     showCancelButton: false,
    //     type: "warning",
    //   }
    //   ).then(() => {//   token过期 需要清空 token
    //     localStorage.removeItem("userToken")
    //     localStorage.removeItem("cache-type")
    //     Cookies.remove('userToken', {
    //       path: '/'
    //     })
    //     Cookies.remove('cache-code', {
    //       path: '/'
    //     })
    //     Cookies.remove('cache-type', {
    //       path: '/'
    //     })
    //     // store.dispatch("out")
    //   });
    // } else {
      const currentPath = router.history.current.path
      // const query = router.history.current.query
      const type = store.getters.getPageType
      const code = store.getters.getPageCode
      const shellId = store.getters.shellId
      const userId = store.getters.userId
      const cooperationType = store.getters.cooperationType
      const systemId = store.getters.systemId || localStorage.getItem('system-id')
      if (['/roleCheck', '/myOrder', '/makeCode', '/aheadInfo', '/infoConfirm', '/payment', '/basicInfo', '/electronicReceipt', '/booksElectronicReceipt', '/booksConfirm', '/stayPayConfirm'].includes(currentPath)) {
        if (isStop) return
        isStop = true
        //   token过期 需要清空 token
        localStorage.removeItem("userToken")
        localStorage.removeItem("cache-type")
        Cookies.remove('userToken', {
          path: '/'
        })
        Cookies.remove('cache-code', {
          path: '/'
        })
        Cookies.remove('cache-type', {
          path: '/'
        })
        setTimeout(function () {
          Message({
            message: "当前用户登录时间超时，请重新登录",
            type: "warning",
            duration: 3 * 1000
          })
          setTimeout(() => {
            isStop = false
            location.reload()
          }, 1000);
          if (window.localStorage.getItem('pay-amount')) {
            window.location.replace(`/outPage/#/roleCheck?type=${type}&code=${code}&payAmount=${window.localStorage.getItem('pay-amount')}&systemId=${systemId}`)
          } else if (['singleStay', 'dormitory', 'dormitoryHelpPay', 'singleStayHelpPay', 'dormitoryReceipt'].includes(type)) {
            window.location.replace(`/outPage/#/roleCheck?type=${type}&code=${code}&userId=${userId}&shellId=${shellId}&systemId=${systemId}`)
          } else window.location.replace(`/outPage/#/roleCheck?type=${type}&code=${code}&cooperationType=${cooperationType}&systemId=${systemId}`)
        }, 1000)
      } else if (['/addressCheck'].includes(currentPath)) {
        cleanLocalToken()
        return
      } else {
        store.dispatch("out")
      }
    // }
  }
}

/**
 * 重定向路径转换
 * @param {*} path 路径
 * @returns 
 */
function formartPathTypeString(path) {
  if (path === "infoConfirm") return "payQuick"
  return path
}

function errorLog(msg) {
  // 显示提示
  Message({
    message: msg,
    type: "error",
    duration: 5 * 1000,
  });
}

function warnLog(msg) {
  // 显示提示
  Message({
    message: msg,
    type: "warning",
    duration: 5 * 1000,
  })
}

const service = axios.create({
  baseURL: "/api", // api的base_url
  timeout: 60000, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    const {
      authorization,
      systemId,
      isSafing,
      getLoginAuthForm
    } = store.getters;
    // 短信验证headers传参
    const {
      graphicCode,
      graphicState,
      phone,
      type,
      code,
      autographType
    } = getLoginAuthForm
    // 赋值headers验证 短信验证接口
    if (config.url === '/jsConfig') {
      config.baseURL = '/wechat'
    }
    config.headers["graphicCode"] = graphicCode
    config.headers["graphicState"] = graphicState
    config.headers["autographType"] = autographType
    config.headers["phone"] = phone
    config.headers["type"] = type
    config.headers["code"] = code
    if (config && config.params && config.params.projectId) {
      config.headers["projectId"] = config.params.projectId
    }
    if (isSafing && !config.safingPass)
      throw new Error("维护中！！！拒绝请求!");
    config.headers["authorization"] = localStorage.getItem('userToken') || Cookies.get('userToken') || authorization

    if (type === 7) {
      config.headers["platform-proxy"] = "am9pbmVhc3QtcGM=";
    } else {
      config.headers["platform-proxy"] = "am9pbmVhc3Qtd2VjaGF0";
    }
    if (localStorage.getItem('isEmbeddedApp') == 1) { // 该判断是用于将学员端这个项目内嵌到app里面去使用， 无语  。。。。。。。。。。
      config.headers["platform-proxy"] = "am9pbmVhc3QtYXBw";
    }
    if (window.localStorage.getItem('isMini') == 1) {
      config.headers["platform-proxy"] = "am9pbmVhc3QtYXBwbGV0";
    } 
    config.headers["joineast-system-id"] = localStorage.getItem("system-id") === 'undefined' || localStorage.getItem("system-id") === null ? systemId ? systemId : 1 : localStorage.getItem("system-id")
    if (config && config.config && config.config.SystemId) {
      config.headers['joineast-system-id'] = config.config.SystemId
    }
    if (!window.location.origin) {
      window.location.origin =
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "");
    }
    if (config && config.customBaseURL) {
      // 动态设置baseURL（区分环境）
      config.baseURL = '/'
      // https://out.joineast.com/dApi/community/schoolAnalyze/analyze
    //   axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
    }
    let requestPath = window.location.href.replace(window.location.origin, "");
    config.headers["joineast-request-path"] = requestPath;
    if (process.env.NODE_ENV === 'development') {
      config.headers['joineast-target'] = 'gjx'
    }
    return config;
  }, (error) => {
    // Do something with request error
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    // console.log('返回结果', response)
    // res 是 axios 返回数据中的 data
    const res = response.data;
    // 这个状态码是和后端约定的
    const code = res.status;
    // 根据 code 进行判断
    let isDownLoad = false
    let isCount = false
    if (response.config.config && response.config.config.isDownLoad) {
      isDownLoad = response.config.config.isDownLoad
    }
    if (response.config.config && response.config.config.count) {
      isCount = response.config.config.count
    }
    if (isDownLoad) {
      return res
    } else if (isCount) {
      return response
    } else if (code === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口
      return res;
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      // console.log('code...', code);
      switch (code) {
        case 200:
          return res;
        case 201:
          if (['/orderNull', '/infoConfirm', '/booksConfirm', '/stayPayConfirm'].includes(router.history.current.path) || ['/roleCheck'].includes(router.history.current.path) && res.msg.includes('验证码已发送但未使用，请注意查收')) {
            return res
          }
          // 跳过全局warnLog，由组件自行弹窗处理（如getTouchStudentApi）
          if (response.config.config && response.config.config.skip201Warn) {
            break;
          }
          warnLog(`${res.msg}`, 201, res)
          break;
        case 202:
          warnLog(`${res.msg}`, 202);
          break;
        case "xxx":
          errorCreate(`[ code: xxx ] ${res.msg}`);
          break;
        default:
          break;
      }
    }
    return response.data
  },
  async (error) => {
    console.log('报错的数据', error.response.status);
    if (error.config.method === 'patch' && error.isAxiosError && !error.response) {
      const appName = isWeixn() ? '微信' : isAlipay() ? '支付宝' : '浏览器'
      Dialog.alert({
        title: '提示',
        message: `当前${appName}版本较低，为保证资金安全，建议升级到最新版本的应用后并前往【系统设置】-【应用】- 【${appName}】 -【清理缓存】即可正常使用！`,
      })
    } else if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "请求错误";
          break;
        case 401:
          error.message = "当前用户登录超时，请重新登录";
          redirectLogin();
          break;
        case 403:
          error.message = "拒绝访问";
          redirectLogin();
          break;
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          console.log('提示报错了？')
          if (error.response.config.responseType === 'blob') {
            await transform(error.response.data).then(res => {
              // console.log(res)
              error.message = res
            })
          } else {
            authErrorHandel(error.response.data.msg)
            // error.message = '服务器内部错误';
            error.message =
              error.response.data.message ||
              error.response.data.msg ||
              "服务器内部错误";
          }
          break;
        case 501:
          error.message = "服务未实现";
          break;
        case 502:
          error.message = "网关错误";
          break;
        case 503:
          if (
            error.response.status === 503 &&
            store.getters.systemType != "pc"
          ) {
            store.dispatch("errOut");
          } else {
            router.push('/systemMainten')
          }
          error.message = error.response.data.msg;
          break;
        case 504:
          error.message = "网关超时";
          break;
        case 505:
          error.message = "HTTP版本不受支持";
          break;
        default:
          break;
      }
    }
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 3 * 1000,
    // });
    return Promise.reject(error)
  }
);

function authErrorHandel(message) {
  if (["/roleCheck", "/infoConfirm", "/classRegistration", "/stayPayConfirm"].includes(router.history.current.path)) {
    Message({
      message: message,
      type: "warning",
      duration: 3 * 1000,
    })
  }
}

export default service;